import { render, staticRenderFns } from "./sendContactListStatementDialog.vue?vue&type=template&id=5c9bc546&"
import script from "./sendContactListStatementDialog.vue?vue&type=script&lang=js&"
export * from "./sendContactListStatementDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports